import React from "react";

const SvgBlogs = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16.7042 11.0622C16.3318 7.29218 13.3325 4.29292 9.5625 3.92053V3.87471H9.25V3.01434C13.7467 3.26564 17.3591 6.87797 17.6104 11.3747H16.75V11.0622H16.7042ZM13.5515 11.0622C13.216 9.01923 11.6055 7.40873 9.5625 7.0732V6.99971H9.25V6.14446C12.0212 6.38843 14.2363 8.60347 14.4803 11.3747H13.625V11.0622H13.5515ZM3.625 13.4372V6.74971H5.125V13.4372C5.125 13.7081 5.17835 13.9763 5.282 14.2265C5.38565 14.4767 5.53757 14.7041 5.72909 14.8956C5.92061 15.0871 6.14798 15.2391 6.39821 15.3427C6.64845 15.4464 6.91665 15.4997 7.1875 15.4997C7.73451 15.4997 8.25911 15.2824 8.64591 14.8956C9.0327 14.5088 9.25 13.9842 9.25 13.4372C9.25 12.8902 9.0327 12.3656 8.64591 11.9788C8.30356 11.6365 7.85325 11.4269 7.375 11.3832V9.87961C9.24988 9.97775 10.75 11.5387 10.75 13.4372C10.75 15.3986 9.14886 16.9997 7.1875 16.9997C5.22614 16.9997 3.625 15.3986 3.625 13.4372Z"
      stroke="#0C0324"
    />
  </svg>
);

export default SvgBlogs;
